import { 
    ASSIGN_PERMISSION_TO_ROLE_REQUEST,
    ASSIGN_PERMISSION_TO_ROLE_SUCCESS,
    ASSIGN_PERMISSION_TO_ROLE_FAILURE,
    CLEAR_PERMISSION_ASSIGNMENT_ERROR,
    FETCH_ASSIGNED_PERMISSIONS_REQUEST,
    FETCH_ASSIGNED_PERMISSIONS_SUCCESS,
    FETCH_ASSIGNED_PERMISSIONS_FAILURE,
    CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR,
    FETCH_ALL_PERMISSIONS_REQUEST,
    FETCH_ALL_PERMISSIONS_SUCCESS,
    FETCH_ALL_PERMISSIONS_FAILURE,
    CLEAR_PERMISSIONS_FETCHING_ERROR,
    FETCH_ALL_PERMISSION_CATEGORIES_REQUEST,
    FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS,
    FETCH_ALL_PERMISSION_CATEGORIES_FAILURE,
    CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR,
    FETCH_ROLE_PERMISSIONS_REQUEST,
    FETCH_ROLE_PERMISSIONS_SUCCESS,
    FETCH_ROLE_PERMISSIONS_FAILURE,
    CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR,
    REMOVE_PERMISSION_FROM_ROLE_REQUEST,
    REMOVE_PERMISSION_FROM_ROLE_SUCCESS,
    REMOVE_PERMISSION_FROM_ROLE_FAILURE,
    CLEAR_PERMISSION_REMOVAL_ERROR

} from "./rolePermissionActionTypes";

import { toast } from "react-toastify";

// Import the axios instance from api module
import api from '../../api/api';





// Define and export a function for assigning a permission to a role
export const assignPermisionToRole = (permissionCategoryId, permissionId, roleId, userLogId, updateLogId) => {
    return async (dispatch) => {
        dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_REQUEST });
            
        try {
            const payload = {
                permissionCategoryId,
                permissionId,
                roleId,
                userLogId,
                updateLogId,
            };

            const response = await api.post('/RolePermission/assign-permission-role', payload);

            dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_SUCCESS, payload: response.data });
            toast.success("Permission added successfully");
            
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "Bad request. Please check your input." });
                    toast.error("Permission could not be added");
                } else if (error.response.status === 404) {
                    dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "Permission could not be added. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: ASSIGN_PERMISSION_TO_ROLE_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};



// Clear permission assignment errors
export const clearPermissionAssignmentError = () => {
    return { type: CLEAR_PERMISSION_ASSIGNMENT_ERROR }
};



// Define and export a function for fetching all permissions
export const fetchAllPermissions = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ALL_PERMISSIONS_REQUEST });

        try {
            const response = await api.get('/RolePermission/permissions/all');
            
            dispatch({ type: FETCH_ALL_PERMISSIONS_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "No permissions were found. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_ALL_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};



// Clear permissions errors from the Redux store
export const clearPermissionsError = () => {
    return { type: CLEAR_PERMISSIONS_FETCHING_ERROR }
};



// Define and export a function for fetching permissions assigned to a role
export const fetchAssignedPermissions = (roleId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_REQUEST });

        try {
            const response = await api.get(`/RolePermission/by-role/${roleId}`);
            dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "This role does not have permissions yet." });
                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_ASSIGNED_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};



// Clear assigned permissions fetching errors from the Redux store
export const clearAssignedPermissionsFetchingError = () => {
    return { type: CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR }
};



// Define and export a function for fetching all permission categories
export const fetchAllPermissionCategories = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_REQUEST });

        try {
            const response = await api.get('/RolePermission/Permission-category');
            
            dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "No permission categories were found. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_ALL_PERMISSION_CATEGORIES_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};



// Clear permission categories errors from the Redux store
export const clearPermissionCategoriesFetchingError = () => {
    return { type: CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR }
};



// Define and export a function for fetching all role permissions
export const fetchAllRolePermissions = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ROLE_PERMISSIONS_REQUEST });

        try {
            const response = await api.get('/RolePermission/all');
            
            dispatch({ type: FETCH_ROLE_PERMISSIONS_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "No role permissions were found. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    }
};



// Clear role permissions errors from the Redux store
export const clearRolePermissionsFetchingError = () => {
    return { type: CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR }
};



// Define and export a function for deleting a permission from a role
export const removePermissionFromRole = (rolePermissionId) => {
    return async (dispatch) => {
        dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_REQUEST });

        try {
            const response = await api.delete(`/RolePermission/delete/${rolePermissionId}`);

            dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "Permission could not be removed. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: REMOVE_PERMISSION_FROM_ROLE_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};




// Clear permission removal error from the Redux store
export const clearPermissionRemovalError = () => {
    return { type: CLEAR_PERMISSION_REMOVAL_ERROR }
};